import AppState from 'AppState';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import Spinner from './shared/Spinner';
import RichTextContent from 'components/shared/RichTextContent';
const PlugSVG = React.lazy(() => import(/* webpackChunkName: "plug-svg" */ './shared/svg/PlugSVG'));

/**
 * View that renders for 404 pages.
 *
 * @class PageNotFound
 * @extends {React.PureComponent}
 */

class PageNotFound extends React.PureComponent {
	public render() {
		const {
			settings: { option1Text404, option2Text404, option1Link404, option2Link404, text404 },
		} = AppState;

		return (
			<div className="main__section">
				<div className="page-not-found">
					<div className="page-not-found__left">
						<h1 className="page-not-found__title">404</h1>
						<RichTextContent className="page-not-found__para" htmlContent={text404} />
						<div className="page-not-found__actions">
							<div className="page-not-found__actions-item">
								{!option1Link404 ? null : (
									<NavLink
										to={option1Link404}
										className="btn btn-primary btn-inline btn-width-xlarge"
									>
										{option1Text404}
									</NavLink>
								)}
								{!option2Link404 ? null : (
									<NavLink
										to={option2Link404}
										className="btn btn-outline-primary-special btn-inline btn-width-xlarge"
									>
										{option2Text404}
									</NavLink>
								)}
							</div>
						</div>
					</div>
					<div className="page-not-found__right">
						<React.Suspense fallback={<Spinner />}>
							<PlugSVG class="page-not-found__plug" />
						</React.Suspense>
					</div>
				</div>
			</div>
		);
	}
}

export default PageNotFound;
